import { render } from "./Menu.vue?vue&type=template&id=42167ef9&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=42167ef9&lang=sass"
import "./Menu.vue?vue&type=style&index=1&id=42167ef9&lang=scss&scoped=true"

import exportComponent from "/Users/don/phpStorm/qr-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42167ef9"]])

export default __exports__